import $ from 'jquery';

$(function () {
    $('.btf a').on('click', function (evt) {
        evt.preventDefault();
        let target = $(this)[0].hash;
        window.scrollTo({ top: $(target).position().top - 100, behavior:'smooth' });
    });
});